// extracted by mini-css-extract-plugin
module.exports = {"btn_content":"style_btn_content__sZnGe"};